import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import './ServicesSection.css';

const ServicesSection = ({ section }) => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get('/services/', { params: { page_size: 6 } });
      setServices(response.data.results || response.data);
    } catch (error) {
      console.error('Error loading services:', error);
    }
  };

  if (services.length === 0) return null;

  return (
    <section className="services-section homepage-section">
      <Container>
        <h2 className="section-title">{section.title}</h2>
        <Row>
          {services.map(service => (
            <Col key={service.id} md={4} sm={6} className="mb-4">
              <Card className="service-card h-100 text-center">
                <Card.Body>
                  {service.icon && (
                    <div className="service-icon">
                      <i className={service.icon}></i>
                    </div>
                  )}
                  <Card.Title>
                    <Link to={`/services/${service.slug}`}>{service.name}</Link>
                  </Card.Title>
                  <Card.Text className="small">
                    {service.description.replace(/<[^>]*>/g, '').substring(0, 100)}...
                  </Card.Text>
                  <Link to={`/services/${service.slug}`} className="btn btn-outline-primary btn-sm">
                    Learn More
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-4">
          <Link to="/services" className="btn btn-primary">View All Services</Link>
        </div>
      </Container>
    </section>
  );
};

export default ServicesSection;
